import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VTabs,
        {
          attrs: { "center-active": "", "fixed-tabs": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.description")))]),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.logs")))]),
          _c(VTab, [
            _vm._v(_vm._s(_vm.$t("create_attribute.detail.periods_tab"))),
          ]),
        ],
        1
      ),
      _c(
        VTabsItems,
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            VTabItem,
            [
              _c(
                VContainer,
                { attrs: { fluid: "" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("create_attribute.table.use_case")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              value: _vm.item.caso_de_uso,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("create_attribute.table.created_date")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              value: _vm.formatDate(_vm.item.fecha_creacion),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(VDivider, { staticClass: "my-4" }),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(VCol, { attrs: { cols: "12" } }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center mb-2" },
                          [
                            _c(
                              "div",
                              { staticClass: "subtitle-2 text--secondary" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.detail.tables_section"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c(VSpacer),
                            _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  color: "primary",
                                                  loading:
                                                    _vm.downloadingScript,
                                                  disabled:
                                                    !_vm.item.automate_id,
                                                },
                                                on: {
                                                  click:
                                                    _vm.downloadOriginalScript,
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-download")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "create_attribute.detail.download_script"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("create_attribute.detail.gcp_table")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              value: _vm.gcpTableName,
                              "append-outer-icon": "mdi-content-copy",
                            },
                            on: {
                              "click:append-outer": function ($event) {
                                return _vm.copyText(_vm.gcpTableName)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.modelTableName
                        ? _c(
                            VCol,
                            { attrs: { cols: "3", lg: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "create_attribute.detail.model_table"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.modelTableName
                        ? _c(
                            VCol,
                            { attrs: { cols: "9", lg: "4" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  filled: "",
                                  readonly: "",
                                  "hide-details": "auto",
                                  dense: "",
                                  value: _vm.modelTableName,
                                  "append-outer-icon": "mdi-content-copy",
                                },
                                on: {
                                  "click:append-outer": function ($event) {
                                    return _vm.copyText(_vm.modelTableName)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.awsOutputTable
                        ? _c(
                            VCol,
                            { attrs: { cols: "3", lg: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "create_attribute.detail.aws_output_table"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.awsOutputTable
                        ? _c(
                            VCol,
                            { attrs: { cols: "9", lg: "4" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  filled: "",
                                  readonly: "",
                                  "hide-details": "auto",
                                  dense: "",
                                  value: _vm.awsOutputTable,
                                  "append-outer-icon": "mdi-content-copy",
                                },
                                on: {
                                  "click:append-outer": function ($event) {
                                    return _vm.copyText(_vm.awsOutputTable)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.info.table_description
                    ? _c(
                        VRow,
                        { staticClass: "mt-2", attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3", lg: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "create_attribute.form.table_description"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "9", lg: "10" } },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  filled: "",
                                  readonly: "",
                                  "hide-details": "auto",
                                  dense: "",
                                  value: _vm.info.table_description,
                                  rows: "3",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.info.periods && _vm.info.periods.length
                    ? _c(
                        VRow,
                        { staticClass: "mt-2", attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3", lg: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("create_attribute.form.periods")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "9", lg: "10" } },
                            [
                              _c(
                                VChipGroup,
                                _vm._l(_vm.info.periods, function (p) {
                                  return _c(
                                    VChip,
                                    { key: p, attrs: { small: "" } },
                                    [_vm._v(_vm._s(p))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(VDataTable, {
                staticClass: "text-center table-inca",
                attrs: {
                  responsive: "",
                  dense: "",
                  items: _vm.logItems,
                  headers: _vm.logHeaders,
                  loading: _vm.loading,
                  "hide-default-footer": "",
                  "sort-by": ["creation_date"],
                  "sort-desc": [true],
                  "items-per-page": _vm.pagination.logs.limit,
                  page: _vm.pagination.logs.current,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.logs, "current", $event)
                  },
                  pagination: function ($event) {
                    _vm.pagination.logs.total = $event.itemsLength
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.creation_date",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-calendar"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateAndHours(item.creation_date).date
                            ) +
                            " "
                        ),
                        _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-clock-outline"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateAndHours(item.creation_date).hour
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "no-data",
                    fn: function () {
                      return [
                        _c(
                          VAlert,
                          {
                            staticClass: "ma-4",
                            attrs: { type: "info", outlined: "" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("create_attribute.history.no_records")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("pagination-vue", {
                attrs: { pagination: _vm.pagination.logs },
              }),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(VDataTable, {
                staticClass: "text-center table-inca",
                attrs: {
                  responsive: "",
                  dense: "",
                  items: _vm.periodItems,
                  headers: _vm.periodHeaders,
                  loading: _vm.loadingPeriods,
                  "hide-default-footer": "",
                  "sort-by": ["creation_date"],
                  "sort-desc": [true],
                  "items-per-page": _vm.pagination.periods.limit,
                  page: _vm.pagination.periods.current,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.periods, "current", $event)
                  },
                  pagination: function ($event) {
                    _vm.pagination.periods.total = $event.itemsLength
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.process_date",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(item.period && item.period.process_date) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.source",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(item.period && item.period.source) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.creation_date",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDateTime(item.creation_date)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.filas_leidas",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.filas_leidas != null
                                ? item.filas_leidas
                                : "—"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.filas_cargadas",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.validation_error
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#d32f2f",
                                  "font-weight": "600",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(item.filas_cargadas) +
                                    " [Error] "
                                ),
                              ]
                            )
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.filas_cargadas != null
                                    ? item.filas_cargadas
                                    : "—"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "item.ultima_fecha_carga",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.validation_error
                          ? _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              {
                                                staticStyle: {
                                                  color: "#d32f2f",
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.ultima_fecha_carga ||
                                                      "—"
                                                  ) +
                                                  " ⚠ "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(item.validation_error)),
                                ]),
                              ]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(item.ultima_fecha_carga || "—")),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "no-data",
                    fn: function () {
                      return [
                        _c(
                          VAlert,
                          {
                            staticClass: "ma-4",
                            attrs: { type: "info", outlined: "" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("create_attribute.history.no_records")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("pagination-vue", {
                attrs: { pagination: _vm.pagination.periods },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }